import {
  type RoomPricesPartitions,
  type PricingPartition,
} from '@/types/benefits/hotel/HotelRoomPricingFormData';
import { numberIfNotUndefined } from '../prices/numberIfNotUndefined';
import {
  pruneUncheckedRoomTypePartitions,
  type RoomTypeFlags,
} from './hotel/pruneUncheckedRoomTypePartitions';

const getPartitionPrices = (partition: PricingPartition) => {
  return {
    price: numberIfNotUndefined(partition.price),
    firstSpecialPrice: numberIfNotUndefined(partition.firstSpecialPrice),
    secondSpecialPrice: numberIfNotUndefined(partition.secondSpecialPrice),
    additionalPrice: numberIfNotUndefined(partition.additionalPrice),
  };
};

export const getAllPricesPartitions = (
  allPricePartitions: RoomPricesPartitions,
  roomTypes: RoomTypeFlags,
) => {
  const pricePartitions = pruneUncheckedRoomTypePartitions(
    allPricePartitions,
    roomTypes,
  );
  return {
    individual: pricePartitions.individual.map((partition) =>
      getPartitionPrices(partition),
    ),
    double: pricePartitions.double.map((partition) =>
      getPartitionPrices(partition),
    ),
    triple: pricePartitions.triple.map((partition) =>
      getPartitionPrices(partition),
    ),
    quadruple: pricePartitions.quadruple.map((partition) =>
      getPartitionPrices(partition),
    ),
  };
};
